import React from "react";
import pdf from "../../../PDF/whitepaper.pdf";

export default function DocumentSection() {
  return (
    <div>
      <section className="lg:pt-[100px] py-[50px]">
        <div className="max-w-[1300px] mx-auto lg:px-10 px-2">
          <div className="lg:mb-[80px] max-w-[1000px] mx-auto lg:px-10 px-4">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              Documents, Terms &amp; Condition
            </h3>
            <p className="text-center lg:text-[18px] sm:text-[15px] text-[14px]">
              Terms of service are rules by which one must agree to abide in
              order to use a service. Terms of service can also be merely a
              disclaimer, especially regarding the use of websites.
            </p>
          </div>
          <div className="flex lg:flex-row flex-col gap-[30px] justify-center">
            <div className="flex-1 lg:mt-0 mt-[50px] lg:pr-[100px]">
              <div className="bg-[#751efe] rounded-[20px] lg:px-8 px-4 py-[60px]">
                <div className="mb-[40px]">
                  <a href="/" className="flex items-center">
                    <h1 className="text-white text-xl text-bold">
                      GLOBAL MENTOR
                    </h1>
                  </a>
                </div>
                <div className="text-white">
                  <h1 className="text-lg pb-2">PRODUCTS & SERVICES</h1>
                  <p>1. DeFi staking</p>
                  <p>2. Real-yield</p>
                  <p>3. Venture Capital Fund</p>
                  <p>4. GLOBAL Investor Dividend Payout Protocol</p>
                </div>
              </div>
            </div>
            <div className="flex-1 mt-[20px]">
              <h3 className="font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[22px] text-[18px]">
                Whitepaper
              </h3>
              <p className="mb-4 lg:text-[16px] text-[14px] text-justify">
                A white paper is an authoritative report or guide that informs
                readers concisely about a complex issue and presents the issuing
                body's philosophy on the matter. It is meant to help readers
                understand an issue, solve a problem, or make a decision.
              </p>
              <p className="mb-4 lg:text-[16px] text-[14px] text-justify">
                Since the early 1990s, the term "white paper", or "whitepaper",
                has been applied to documents used as marketing or sales tools
                in business.
              </p>
              <div className="flex items-center">
                <a href={pdf} download>
                  <img src="assets/Solid.svg" className="mr-2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
